import { Component, OnInit } from '@angular/core';
import { MainService } from 'src/app/services/main/main.service';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-iframe-tila',
    templateUrl: './iframe-tila.component.html',
    styleUrls: ['./iframe-tila.component.scss']
})
export class IframeTllaComponent implements OnInit {
    closure_html = 'Loading...';
    env: any = environment;
    constructor(
        public _mainService: MainService) {
    }

    ngOnInit() {
        this.getClosureHTML();
    }
    getClosureHTML() {
        var form = new FormData();
        let iframe_tila_data = JSON.parse(String(localStorage.getItem('iframe_tila_data')));
        form.append('access_token', localStorage.getItem('token'));
        form.append('contract_id', iframe_tila_data.contract_id);
        form.append('start_date', iframe_tila_data.start_date);
        if (iframe_tila_data.source_id && iframe_tila_data.source_id > 0) {
            form.append('source_id', iframe_tila_data.source_id);
        }
        
        this._mainService.uploadApi(form, `get_closure_html`, true)
            .subscribe(response => {
                if (response && response.is_error) {
                    return false;
                } else {
                    this.closure_html = response.template_content;
                }
            });
    }
}